import { registerAction } from '../../Action'

export const UPDATE_JSON_API_ENTITY = 'UPDATE_JSON_API_ENTITY'

export const reducer = (state = {}, action) => {
  const { type, id, attributes, relationships } = action.payload

  const entity = state.jsonApiEntities[type][id]

  return {
    ...state,
    jsonApiEntities: {
      ...state.jsonApiEntities,
      [type]: {
        ...state.jsonApiEntities[type],
        [id]: {
          ...entity,
          ...attributes,
          relationships: {
            ...entity.relationships,
            ...relationships,
          },
        },
      },
    },
  }
}

const updateJsonApiEntity = registerAction(UPDATE_JSON_API_ENTITY, { reducer })

export default updateJsonApiEntity
